module.exports = "https://www.gc-pro.gnp.com.mx/4095c2bd343cf4638531efa5b4dc0994.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/telefono.svg.svg
// module id = 992
// module chunks = 0